module.exports = __webpack_public_path__ + "static/media/gu.d4375e9d.svg";